import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import {
  hasKeycloakAuth,
  useAccessTokenInterceptor,
  useAuth,
  useAuthenticatedUser
} from '@pasqal/core/hooks/useAuth';
import Loading from './components/Loading';
import SvgGlobalDefs from './components/SvgGlobalDefs/SvgGlobalDefs';
import ExperimentPage from './pages/ExperimentPage';
import HomePage from './pages/HomePage';
import { AlertProvider } from './systems/alert';
import { ContextMenuProvider } from './systems/contextMenu';
import { HelpProvider } from './systems/help';
import { TitleProvider } from './systems/title';

import './App.css';

// Auth0 guard for non-keycloak setups
const Auth0ProtectedExperimentPage = withAuthenticationRequired(
  ExperimentPage,
  {
    onRedirecting: () => <div />
  }
);

// Keycloak guard: redirect to login if not authenticated
function KeycloakProtectedExperimentPage() {
  const { isAuthenticated, isLoading } = useAuthenticatedUser();
  const { goToLoginPage } = useAuth();

  if (isLoading) {
    return <Loading />;
  }
  if (!isAuthenticated) {
    goToLoginPage();
    return <Loading />; // Safe guard because goToLoginPage is async
  }
  return <ExperimentPage />;
}

const ProtectedExperimentPage = hasKeycloakAuth
  ? KeycloakProtectedExperimentPage
  : Auth0ProtectedExperimentPage;

function AppInner() {
  const { addAccessTokenInterceptor, interceptorParam } =
    useAccessTokenInterceptor();

  useEffect(() => {
    addAccessTokenInterceptor(interceptorParam);
  }, [addAccessTokenInterceptor, interceptorParam]);

  return (
    <>
      <SvgGlobalDefs />
      <div className="LayoutContainer">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/experiment" element={<ProtectedExperimentPage />} />
        </Routes>
      </div>
    </>
  );
}

export default function App() {
  return (
    <AlertProvider>
      <HelpProvider>
        <TitleProvider>
          <ContextMenuProvider>
            <AppInner />
          </ContextMenuProvider>
        </TitleProvider>
      </HelpProvider>
    </AlertProvider>
  );
}
